import React from 'react';
import styled from 'styled-components';
import Button from '../../../components/Button/Button';
import Screens from 'shared/screens';
import { useDispatch } from 'shared/node_modules/react-redux';
import useSendInitiatePurchaseLog from 'shared/hooks/purchase/useSendInitiatePurchaseLog';
import { assignTransationUUID } from 'shared/state/actions/purchase';
import Logger from 'shared/lib/analytics/logger';
import QueryParamProxy from 'shared/utils/queryParamProxy';
import RouteParamConstants from 'shared/utils/routeParamConstants';
import { getText, TEXT_KEY } from 'shared/utils/localization';
import { BUTTON_STROKES } from 'shared/utils/buttonTextStrokes';
import { ASSET_KEY, assetSource } from 'shared/utils/assetSource';
import { purchaseActionTriggers } from 'shared/constants/userActions';

function PiggyBankBreakButton({ purchasePackage, availableToBreak }) {
  const dispatch = useDispatch();
  const { sendInitiatePurchaseLog } = useSendInitiatePurchaseLog();

  const handleBreak = () => {
    const UUID = Logger.generateUUID();
    dispatch(assignTransationUUID(UUID));
    const purchaseLogObject = {
      sku: purchasePackage.cpilId,
      amount: purchasePackage.pricePoint,
      pType: purchasePackage.purchaseType,
      trigger: purchaseActionTriggers.PIGGY_BANK_BREAK_BUTTON,
      UUID,
    };
    sendInitiatePurchaseLog(purchaseLogObject);
    const productSku = purchasePackage.cpilId;
    QueryParamProxy.setQueryParams({
      [RouteParamConstants.PARAM_MODAL]: Screens.PurchaseFlow,
      [RouteParamConstants.PARAM_PURCHASE_SKU]: productSku,
      [RouteParamConstants.PARAM_PURCHASE_TYPE]: purchasePackage.purchaseType,
      [RouteParamConstants.PARAM_PURCHASE_NAME]: purchasePackage.purchaseType,
      [RouteParamConstants.PARAM_OFFER_DETAIL]: {
        sku: productSku,
        name: purchasePackage.purchaseType,
        type: purchasePackage.purchaseType,
        amount: purchasePackage.coinsAmount,
        price: purchasePackage.pricePoint,
        cpil_id: purchasePackage.cpilId,
      },
    });
    Logger.setActionTrigger(purchaseActionTriggers.PIGGY_BANK_BREAK_BUTTON);
  };

  return (
    <BreakButton
      onClick={handleBreak}
      disabled={!availableToBreak}
      textStroke={BUTTON_STROKES.PRIMARY}
      label={`${getText(TEXT_KEY.PIGGY_BANK_BREAK_BUTTON)} $${purchasePackage.pricePoint}`}
    />
  );
}

export default PiggyBankBreakButton;

const BreakButton = styled(Button).attrs(({ disabled }) => ({
  containerStyle: `
    position: absolute;
    bottom: -1dvw;
    width: 22dvw;
    cursor: pointer;
    z-index: 1;
  `,
  textStyle: { textTransform: 'uppercase', fontSize: '2dvw', letterSpacing: '-1.5px' },
  imageStyle: { width: '100%', objectFit: 'contain' },
  imageSource: disabled
    ? assetSource(ASSET_KEY.ROUNDEDRECT_DISABLED_WIDE)
    : assetSource(ASSET_KEY.ROUNDEDRECT_PRIMARY_WIDE),
}))``;

